import { Action, Dispatch } from 'redux';
import {
  alertAssignmentInternalApi,
  noteInternalApi,
  sanctionAlertDocumentInternalApi,
  sanctionAlertsApi,
} from '../apis';
import { updateScreeningAlertSuccess } from './screeningReducer';
import { showFeedback } from '../feedback/feedbackReducer';
import { SanctionNotesFormValues } from './ScreeningAlertStatus';
import { InternalApiAlertType } from '../api-internal';

export const assignScreeningAlert =
  (screeningAlertId: number, assigneeId: number) =>
  async (dispatch: Dispatch): Promise<Action> => {
    await alertAssignmentInternalApi.assignAlert({
      internalApiAlertAssignmentCommand: {
        alertId: screeningAlertId,
        alertType: InternalApiAlertType.SCREENING,
        assigneeId,
      },
    });
    await sanctionAlertsApi.getSanctionAlert({
      sanctionAlertId: screeningAlertId,
    });
    return dispatch(updateScreeningAlertSuccess());
  };

export const saveScreeningNote =
  ({ content, sanctionAlertId }: SanctionNotesFormValues) =>
  async (dispatch: Dispatch) => {
    const { id } = await noteInternalApi.addSanctionNote({
      sanctionAlertId,
      apiNote: { content, sanctionAlertId },
    });
    dispatch(showFeedback({ message: `Note #${id} added!`, success: true }));
  };

export const uploadScreeningAlertDocuments =
  (files: File[] | null, sanctionAlertId: number) => async (dispatch: Dispatch) => {
    if (files !== null) {
      await Promise.all(
        files.map(async (file) => {
          return await sanctionAlertDocumentInternalApi.uploadSanctionAlertDocument({
            sanctionAlertId,
            file,
          });
        })
      );

      const message = files.length === 1 ? 'Document uploaded' : `${files?.length} documents uploaded`;

      dispatch(
        showFeedback({
          message: message,
          success: true,
        })
      );
    }
  };
